import { InventoryTypeField } from "../responses/inventory_type/InventoryTypeField"
import { InventoryTypeFieldSearchValueMessage } from "../messages/InventoryTypeFieldSearchValueMessage"

export class InventoryTypeSearchFieldModel {
  field: InventoryTypeField
  value: InventoryTypeFieldSearchValueMessage

  constructor(field: InventoryTypeField, value: InventoryTypeFieldSearchValueMessage) {
    this.field = field
    this.value = value
  }
}
  